import { useAuthStore } from '@/store/authStore';
import { getHomePathForUser } from '@/utils/user-role';
import { router } from 'expo-router';
import React, { useEffect } from 'react';
import { View } from 'react-native';

export default function TabsEntryScreen() {
  const { user } = useAuthStore();

  useEffect(() => {
    if (!user) return;

    // Sem plano não há paywall: o prestador entra no gratuito.
    router.replace(getHomePathForUser(user));
  }, [user]);

  return <View className="flex-1 bg-canvas" />;
}
